import { useState } from 'react'
import { Routes, Route } from 'react-router'
import styled from 'styled-components'
import DrawerMenu from 'mobile/common/drawer'
import Header from 'mobile/common/header'
import Home from 'mobile/pages/Home/home'
import PriorityProgramme from 'mobile/pages/PriorityProgramme/priorityprogramme'
import EarnWins from 'mobile/pages/EarnWins/earnwins'
import SpendWins from 'mobile/pages/SpendWins/spendwins'
import HelpCentre from 'mobile/pages/HelpCentre/helpcentre'
import QuickLinks from 'mobile/common/quicklinks'
import Footer from 'mobile/common/footer'

const PageContainer = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

function MobileViewApp() {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const drawerToggle = () => {
        setIsDrawerOpen(!isDrawerOpen)
    }
    const drawerClose = () => {
        setIsDrawerOpen(false)
    }
    return (
        <PageContainer>
            <DrawerMenu isOpen={isDrawerOpen} setDrawerClose={drawerClose} />
            <Header setIsDrawerOpen={drawerToggle} />
            <Routes>
                <Route index element={<Home />} />
                <Route
                    path="hkjcpriorityprogramme"
                    element={<PriorityProgramme />}
                />
                <Route path="earnwins" element={<EarnWins />} />
                <Route path="spendwins" element={<SpendWins />} />
                <Route path="helpcentre" element={<HelpCentre />} />
            </Routes>
            <QuickLinks />
            <Footer />
        </PageContainer>
    )
}

export default MobileViewApp
